import React, { Component } from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FUNNEL_START, FUNNEL_ANSWER, FUNNEL_CONTACT } from 'utils/constants';

const STEPS = [
  {
    step: 1,
    label: null,
    question: "Wie viel Erfahrung hast du als LKW-Fahrer:in bzw. mit Spezialfahrzeugen?",
    type: 'single',
    options: ['< 1 Jahr', '1-3 Jahre', '3-5 Jahre', '> 5 Jahre', 'Leider noch keine'],
    key: 'experience',
  },
  {
    step: 2,
    label: null,
    question: "Welche dieser Aufgaben hast du in diesem Bereich bereits übernommen?",
    subtitle: "Mehrfachauswahl möglich",
    type: 'multi',
    options: [
      'LKW / Spezialfahrzeuge lenken und bedienen',
      'Fahrzeuge kontrollieren und warten',
      'Mit Pumpen arbeiten',
      'Mit Saugrobotern arbeiten',
      'Sicherheitsvorschriften einhalten',
      'Andere',
      'Keine Erfahrung',
    ],
    key: 'tasks',
  },
  {
    step: 3,
    label: null,
    question: "Welche Führerscheine / Nachweise bringst du mit?",
    subtitle: "Mehrfachauswahl möglich",
    type: 'multi',
    options: ['Führerschein C', 'C95', 'Keinen davon'],
    key: 'licenses',
  },
  {
    step: 4,
    label: null,
    question: "Hast du bereits eine ADR Card?",
    type: 'single',
    options: ['Ja', 'Nein, aber ich wäre offen es zu machen', 'Nein'],
    key: 'adr',
  },
  {
    step: 5,
    label: null,
    question: "Wie gut sind deine Deutschkenntnisse?",
    type: 'single',
    options: ['Muttersprache', 'Sehr gut', 'Gut, ich komme zurecht', 'Ich lerne noch'],
    key: 'german',
  },
  {
    step: 6,
    label: null,
    question: "Welche Eigenschaften treffen am besten auf dich zu?",
    subtitle: "Mehrfachauswahl möglich",
    type: 'multi',
    options: ['zuverlässig', 'verantwortungsbewusst', 'belastbar', 'sicherheitsorientiert', 'genau', 'selbstständig'],
    key: 'traits',
  },
  {
    step: 7,
    label: null,
    question: "Wann könntest du bei uns starten?",
    type: 'single',
    options: ['Sofort', 'In 1 Monat', 'In 1-3 Monaten', 'Noch unklar'],
    key: 'startDate',
  },
  {
    step: 8,
    label: null,
    question: "Möchtest du uns gern noch etwas mitteilen?",
    type: 'textarea',
    key: 'message',
  },
];


class JobQuiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      funnelId: null,
      sessionId: null,
      currentQuestion: null,
      currentAnswer: null,
      quizState: 'loading',  // 'loading' | 'active' | 'complete' | 'reject'
      submitting: false,
      // contact form
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      availability: [],
      linkedIn: '',
      consent: false,
      submitted: false,
      contactSubmitting: false,
      modalOpen: false,
    };
    this.handleSingleChoice = this.handleSingleChoice.bind(this);
    this.toggleMultiChoice = this.toggleMultiChoice.bind(this);
    this.handleWeiter = this.handleWeiter.bind(this);
    this.toggleAvailability = this.toggleAvailability.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.callAnswerEndpoint = this.callAnswerEndpoint.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = this.props.funnelConfig.documentTitle;
    const params = new URLSearchParams(this.props.location.search);
    const funnelId = params.get('funnel_id');
    const adId = params.get('ad_set');
    fetch(FUNNEL_START, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ funnel_id: funnelId, ad_id: adId }) })
      .then(res => res.json())
      .then(data => {
        this.setState({
          funnelId: data.funnel_id,
          sessionId: data.session_id,
          currentQuestion: data.question,
          currentAnswer: data.question.type === 'multi' ? [] : null,
          quizState: 'in_progress',
        });
      })
      .catch(() => this.setState({ quizState: 'error' }));
  }

  callAnswerEndpoint(answer) {
    const { funnelId, sessionId, currentQuestion } = this.state;
    this.setState({ submitting: true });
    fetch(FUNNEL_ANSWER, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ funnel_id: funnelId, session_id: sessionId, question_id: currentQuestion.id, answer }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.state === 'in_progress') {
          this.setState({
            currentQuestion: data.question,
            currentAnswer: data.question.type === 'multi' ? [] : null,
            quizState: 'in_progress',
            submitting: false,
          });
        } else {
          this.setState({ quizState: data.state, submitting: false });
        }
      })
      .catch(() => this.setState({ submitting: false }));
  }

  handleSingleChoice(value) {
    this.callAnswerEndpoint(value);
  }

  toggleMultiChoice(value) {
    this.setState(prev => {
      const current = prev.currentAnswer || [];
      return {
        currentAnswer: current.includes(value)
          ? current.filter(v => v !== value)
          : [...current, value],
      };
    });
  }

  handleWeiter() {
    const { currentQuestion, currentAnswer } = this.state;
    this.callAnswerEndpoint(currentQuestion.type === 'multi' ? (currentAnswer || []) : (currentAnswer || ''));
  }

  toggleAvailability(value) {
    this.setState(prev => {
      const current = prev.availability;
      return {
        availability: current.includes(value)
          ? current.filter(v => v !== value)
          : [...current, value],
      };
    });
  }

  handleSubmit() {
    const { sessionId, firstName, lastName, email, phone, availability, linkedIn, consent } = this.state;
    if (!firstName || !lastName || !email || !phone) return;

    this.setState({ contactSubmitting: true });
    const availabilityMap = { vormittags: 'morning', mittags: 'mid_day', nachmittags: 'evening' };

    fetch(FUNNEL_CONTACT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId,
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone_number: phone,
        availability: availability.map(a => availabilityMap[a]),
        social_profile_url: linkedIn,
        save_data_for_two_years: consent,
      }),
    })
      .then(() => this.setState({ submitted: true, contactSubmitting: false }))
      .catch(() => this.setState({ submitted: true, contactSubmitting: false }));
  }

  getMomentumProgress() {
    const { currentQuestion, quizState } = this.state;
    if (quizState === 'accepted' || quizState === 'rejected') return 97;
    if (!currentQuestion) return 5;
    return Math.round((1 - Math.pow(0.82, currentQuestion.step)) * 96);
  }

  renderLogoHeader() {
    const { companyLogo, companyName } = this.props.funnelConfig;
    return (
      <div className="text-center py-3 border-bottom mb-3">
        <img src={companyLogo} alt={companyName} style={{ height: 60, objectFit: 'contain' }} />
      </div>
    );
  }

  renderProgressBar() {
    const progress = this.getMomentumProgress();
    return (
      <div className="px-4 mb-4">
        <div className="rounded-pill overflow-hidden" style={{ height: 8, background: '#e9ecef' }}>
          <div
            className="bg-danger h-100 rounded-pill"
            style={{ width: `${progress}%`, transition: 'width 0.5s ease-out' }}
          />
        </div>
      </div>
    );
  }

  renderQuestion() {
    const { currentQuestion, currentAnswer, submitting } = this.state;
    if (!currentQuestion) return null;

    const selectedValues = currentAnswer || [];
    const charCount = (currentAnswer || '').length;

    return (
      <div className="px-3 flex-grow-1 d-flex flex-column">
        <h4 className="fw-bold text-center mb-1 px-2">{currentQuestion.question}</h4>
        {currentQuestion.subtitle && (
          <p className="text-muted text-center mb-2 small">{currentQuestion.subtitle}</p>
        )}

        {currentQuestion.type !== 'textarea' && (
          <div className="mt-3">
            {currentQuestion.options.map(option => {
              const isSelected = currentQuestion.type === 'multi' && selectedValues.includes(option);
              return (
                <button
                  key={option}
                  className="w-100 py-3 mb-2 bg-white d-flex align-items-center justify-content-between px-3"
                  style={{
                    borderRadius: 10,
                    border: isSelected ? '2px solid #dc3545' : '1.5px solid #e0e0e0',
                    color: '#1a1a1a',
                    fontSize: 16,
                    cursor: submitting ? 'not-allowed' : 'pointer',
                    boxShadow: isSelected ? 'none' : '0 1px 4px rgba(0,0,0,0.06)',
                    opacity: submitting ? 0.6 : 1,
                  }}
                  disabled={submitting}
                  onClick={() =>
                    currentQuestion.type === 'multi'
                      ? this.toggleMultiChoice(option)
                      : this.handleSingleChoice(option)
                  }
                >
                  <span>{option}</span>
                  {isSelected && <i className="bi bi-check-circle-fill text-danger" />}
                </button>
              );
            })}
          </div>
        )}

        {currentQuestion.type === 'textarea' && (
          <div className="mt-3 position-relative">
            <textarea
              className="form-control"
              rows={8}
              placeholder="Optional – nur, wenn du möchtest."
              maxLength={250}
              value={currentAnswer || ''}
              onChange={e => this.setState({ currentAnswer: e.target.value })}
              style={{ borderRadius: 8, resize: 'none', paddingTop: 32 }}
            />
            <span className="text-muted small position-absolute" style={{ top: 8, right: 12 }}>
              {250 - charCount}
            </span>
          </div>
        )}

        {(currentQuestion.type === 'multi' || currentQuestion.type === 'textarea') && (
          <button
            className="btn btn-danger w-100 py-3 rounded-3 fw-bold fs-5 mt-3"
            onClick={this.handleWeiter}
            disabled={submitting || (currentQuestion.type === 'multi' && selectedValues.length === 0)}
          >
            {submitting ? <i className="bi bi-arrow-repeat" /> : 'Weiter'}
          </button>
        )}
      </div>
    );
  }

  renderContactForm() {
    const { firstName, lastName, email, phone, availability, consent, contactSubmitting } = this.state;
    const canSubmit = firstName && lastName && email && phone;

    return (
      <div className="px-3 flex-grow-1">
        <div className="text-center mb-4">
          <h5>Fast, geschafft!</h5>
          <h5 className="fw-semibold">
            Du bist für die Stelle qualifiziert.
          </h5>
          <p >Hinterlasse uns kurz deine Kontaktdaten – wir melden uns in Kürze bei dir.</p>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Vorname</label>
          <input
            type="text"
            className="form-control form-control-lg"
            value={firstName}
            onChange={e => this.setState({ firstName: e.target.value })}
          />
        </div>
        <div className="mb-3">
          <label className="form-label fw-semibold">Nachname</label>
          <input
            type="text"
            className="form-control form-control-lg"
            value={lastName}
            onChange={e => this.setState({ lastName: e.target.value })}
          />
        </div>
        <div className="mb-3">
          <label className="form-label fw-semibold">E-Mail-Adresse</label>
          <input
            type="email"
            className="form-control form-control-lg"
            value={email}
            onChange={e => this.setState({ email: e.target.value })}
          />
        </div>
        <div className="mb-3">
          <label className="form-label fw-semibold">Telefonnummer</label>
          <input
            type="tel"
            className="form-control form-control-lg"
            value={phone}
            onChange={e => this.setState({ phone: e.target.value })}
          />
          <p className="text-muted small mt-1 mb-0"><em>Wir verwenden deine Nummer nur für die Kontaktaufnahme zu dieser Stelle.</em></p>
        </div>

        {/* <div className="mb-3">
          <label className="form-label fw-semibold">Telefonische Erreichbarkeit</label>
          <div className="d-flex gap-2 flex-wrap">
            {['vormittags', 'mittags', 'nachmittags'].map(time => {
              const selected = availability.includes(time);
              return (
                <button
                  key={time}
                  type="button"
                  onClick={() => this.toggleAvailability(time)}
                  style={{
                    padding: '8px 18px',
                    borderRadius: 999,
                    border: `2px solid ${selected ? '#D5232E' : '#C2D2DE'}`,
                    background: selected ? '#D5232E' : '#fff',
                    color: selected ? '#fff' : '#17293C',
                    fontWeight: 600,
                    fontSize: 14,
                    cursor: 'pointer',
                    transition: 'all .12s ease',
                  }}
                >
                  {time}
                </button>
              );
            })}
          </div>
        </div> */}

        {/* <div className="mb-3">
          <label className="form-label fw-semibold">
            Du hast ein Profil auf LinkedIn, Xing &amp; Co.? Teile gerne einen Link (optional)
          </label>
          <input
            type="text"
            className="form-control form-control-lg"
            value={linkedIn}
            onChange={e => this.setState({ linkedIn: e.target.value })}
          />
        </div> */}

        {/* <div className="d-flex align-items-start gap-2 mb-4">
          <input
            type="checkbox"
            className="form-check-input flex-shrink-0 mt-1"
            id="consent"
            checked={consent}
            onChange={e => this.setState({ consent: e.target.checked })}
            style={{ width: 24, height: 24 }}
          />
          <label className="form-check-label" htmlFor="consent">
            Ich bin damit einverstanden, dass meine Daten bis zu 2 Jahre aufbewahrt werden dürfen und
            ich in diesem Zeitraum auch für andere passende Stellenausschreibungen kontaktiert werden darf.
          </label>
        </div> */}

        <button
          className="btn btn-danger w-100 py-3 rounded-3 fw-bold fs-5 mb-1"
          onClick={this.handleSubmit}
          disabled={!canSubmit || contactSubmitting}
        >
          {contactSubmitting
            ? <span className="spinner-border spinner-border-sm" role="status" />
            : 'Bewerbung abschicken'}
        </button>

        <div className="text-center py-4">
          <p className="mt-3 mb-0">
            Deine Daten sind sicher.{' '}
            <button
              className="btn btn-link p-0 text-danger"
              style={{ fontSize: 'inherit', verticalAlign: 'baseline' }}
              onClick={() => this.setState({ modalOpen: true })}
            >
              Mehr erfahren
            </button>
          </p>
        </div>
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="text-center text-muted small py-3 border-top mt-4 px-3">
        <div>Powered by ZoneAid</div>
        <div className="d-flex justify-content-center gap-3">
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum" className="text-dark text-decoration-underline">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb" className="text-dark text-decoration-underline">Nutzungsbedingungen</Link>
        </div>
        <div className="mt-1">
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz" className="text-dark text-decoration-underline">Datenschutzerklärung</Link>
        </div>
      </div>
    );
  }

  renderThankYou() {
    return (
      <div className="d-flex flex-column min-vh-100 bg-white" style={{ maxWidth: 480, margin: '0 auto' }}>

        {/* Hero */}
        <div className="position-relative overflow-hidden" style={{ height: 280, background: '#b0c4d4' }}>
          <div
            className="position-absolute top-0 start-0 h-100 d-flex flex-column justify-content-center p-4"
            style={{ background: 'rgba(144,175,196,0.88)', width: '60%', clipPath: 'polygon(0 0, 90% 0, 68% 100%, 0 100%)' }}
          >
            <div className="fw-bold text-white lh-1 mt-2" style={{ fontSize: 26 }}>
              VIELEN DANK<br />FÜR DEINE<br />BEWERBUNG
            </div>
          </div>
          <img
            src={this.props.funnelConfig.quiz.handshakeImg}
            alt=""
            className="position-absolute top-0 end-0 h-100"
            style={{ width: '50%', objectFit: 'cover', objectPosition: 'center top' }}
          />
          <img
            src={this.props.funnelConfig.companyLogo}
            alt=""
            className="position-absolute"
            style={{ top: 12, right: 12, height: 36, objectFit: 'contain' }}
          />
          <img
            src={this.props.funnelConfig.aiDisclaimer}
            alt=""
            className="position-absolute"
            style={{ bottom: 12, right: 12, height: 20, objectFit: 'contain' }}
          />
        </div>

        {/* Content */}
        <div className="text-center px-4 py-5 flex-grow-1">
          <h5 className="fw-bold mb-4">
            Vielen Dank für dein Interesse, deine Zeit und deine Bewerbung!
          </h5>
          <p>
            Deine Bewerbung ist bei uns eingegangen und wir werden uns in Kürze mit
            dir entweder telefonisch oder per E-Mail in Verbindung setzen.
          </p>
          <p>Wir freuen uns bereits darauf, dich besser kennen zu lernen.</p>
          <div style={{ fontSize: 64 }}>🙏</div>
        </div>

        {this.renderFooter()}
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-danger" role="status" />
      </div>
    );
  }

  renderReject() {
    return (
      <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center px-4">
        <i className="bi bi-emoji-frown text-secondary" style={{ fontSize: 64 }} />
        <h4 className="fw-bold mt-4">Sehr schade, aber dieses mal hat es leider nicht geklappt.</h4>
        <p className="mt-3">
          Leider erfüllst du nicht die für uns wirklich sehr wichtige Voraussetzung.
        </p>
        <p>
          Jede Position bringt ihre eigenen Anforderungen und Aufgaben mit sich. Bitte zögere nicht,
          dich wieder bei uns zu bewerben, wenn dich in Zukunft eine unserer offenen Positionen
          interessiert. Heute hat es nicht geklappt, vielleicht aber beim nächsten Mal.
        </p>
        <p>
          Wir bedanken uns für dein Interesse und wünschen dir weiterhin viel Erfolg und alles Gute!
        </p>
      </div>
    );
  }

  renderDataModal() {
    const { modalOpen } = this.state;
    if (!modalOpen) return null;
    return (
      <>
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Datenschutz</h5>
                <button type="button" className="btn-close" onClick={() => this.setState({ modalOpen: false })} />
              </div>
              <div className="modal-body small">
                <p>
                  Deine Daten sind bei uns sicher! Ausschließlich wir und unser mit der
                  administrativ-technischen Umsetzung des Recruitingprozesses mitbefasstes
                  Partnerunternehmen (zoneaid.io) haben Zugang zu Deinen Daten und nutzen sie nur,
                  um Deine Bewerbung bearbeiten und mit Dir in Kontakt treten zu können. Deine Daten
                  werden von uns ohne Deine vorherige Einwilligung weder an Dritte weitergegeben,
                  noch werden Schnittstellen und Anwendungen genutzt, die eine solche Weitergabe
                  bewirken würden.
                </p>
                <p className="mb-0">
                  Du findest alle Informationen zum Thema Datenschutz vollkommen transparent in der{' '}
                  <Link to="/job/datenschutz" target="_blank" rel="noopener noreferrer" className="text-danger">Datenschutzerklärung.</Link>
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.setState({ modalOpen: false })}>Schließen</button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" onClick={() => this.setState({ modalOpen: false })} />
      </>
    );
  }

  renderSubmittingOverlay() {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        zIndex: 100,
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner-border text-danger" style={{ width: 40, height: 40 }} role="status">
            <span className="visually-hidden">Laden...</span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { quizState, submitted, submitting } = this.state;
    if (submitted) return this.renderThankYou();

    return (
      <div className="d-flex flex-column min-vh-100 bg-white" style={{ maxWidth: 480, margin: '0 auto' }}>
        {this.renderDataModal()}
        {submitting && this.renderSubmittingOverlay()}
        {this.renderLogoHeader()}
        {this.renderProgressBar()}
        {quizState === 'loading' && this.renderLoading()}
        {quizState === 'in_progress' && this.renderQuestion()}
        {quizState === 'accepted' && this.renderContactForm()}
        {quizState === 'rejected' && this.renderReject()}
        {quizState === 'error' && (
          <div className="flex-grow-1 d-flex align-items-center justify-content-center text-center px-4">
            <p className="text-muted">Etwas ist schiefgelaufen. Bitte lade die Seite neu.</p>
          </div>
        )}
        {this.renderFooter()}
      </div>
    );
  }
}

export default JobQuiz;
